<ion-item lines="none" class="tile-item">
  <div class="tile-container">
    <ion-grid>
      <ion-row class="title">
        <ion-col>
          <div class="time-title">{{ title() }}</div>
        </ion-col>
        <ion-col>
          @if (!disabled() && minutesDone() > 0 && !isDisplayingDetails) {
            <a (click)="onChangeDetailsBtnClick()" class="more-details-btn">
              {{ 'TIME_COUNTER.SHOW_MORE' | translate }}
            </a>
          }
          @if (!disabled() && minutesDone() > 0 && isDisplayingDetails) {
            <a (click)="onChangeDetailsBtnClick()" class="more-details-btn">
              {{ 'TIME_COUNTER.SHOW_LESS' | translate }}
            </a>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
    <hr />
    <div class="progress-bar-container-wrapper">
      <progress-bar [disabled]="disabled()" [percent]="timePercent"></progress-bar>
    </div>
    @if (!disabled()) {
      <!-- prettier-ignore -->
      <span class="time-display-container">{{ 'TIME_COUNTER.TEXT' | translate }} (<span class="time-display">{{ timeToDisplay }}</span>)</span>
    } @else {
      <span>{{ 'TIME_COUNTER.TEXT_DISABLED' | translate }}</span>
    }
    <div class="gauge-bar-panel" [ngClass]="{ open: isDisplayingDetails && !disabled() }">
      <gauge-bar [gaugeData]="gaugeData()"></gauge-bar>
    </div>
  </div>
</ion-item>
